import { ProductType } from '@/shared/types/product'

import { TCartItem } from '../types/cart-item'

/**
 * Calculates the number of service in the basket current product
 * @param productId - id of product
 * @param cartItems - products from cart
 */
export const getCartServicesPriceByProduct = (cartItems: TCartItem[], productId: number): number => {
	let currentPriceServices = 0

	cartItems.forEach(({ RELATED_PRODUCTS, TYPE_PRODUCTS, PRICE }) => {
		if (
			TYPE_PRODUCTS === ProductType.Service ||
			(TYPE_PRODUCTS === ProductType.Accessory && RELATED_PRODUCTS === productId)
		) {
			currentPriceServices += PRICE.VALUE
		}
	})

	return currentPriceServices
}
